// Observe only this application's requests. No URL, body, token or response is retained.
const active = new Map()
const listeners = new Set()
let nextId = 0
let snapshot = Object.freeze({ count: 0, mutations: 0, startedAt: null })
const publish = () => {
  const requests = [...active.values()]
  snapshot = Object.freeze({ count: requests.length, mutations: requests.filter(r => r.mutation).length,
    startedAt: requests.length ? Math.min(...requests.map(r => r.startedAt)) : null })
  listeners.forEach(listener => listener())
}
export const subscribeActivity = listener => { listeners.add(listener); return () => listeners.delete(listener) }
export const getActivity = () => snapshot
export function beginActivity(mutation = false) {
  const id = ++nextId
  active.set(id, { mutation, startedAt: Date.now() }); publish()
  return () => { if (active.delete(id)) publish() }
}
export async function activityFetch(input, init) {
  const raw = typeof input === 'string' ? input : input?.url
  let own = false
  try {
    const url = new URL(raw, window.location.href)
    own = url.origin === window.location.origin && /^\/(api|auth)\//.test(url.pathname)
  } catch { /* Keep native fetch's error behavior. */ }
  if (!own) return window.fetch(input, init)
  const method = (init?.method || input?.method || 'GET').toUpperCase()
  const finish = beginActivity(!['GET', 'HEAD', 'OPTIONS'].includes(method))
  try { return await window.fetch(input, init) }
  finally { finish() }
}
